<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/l8hMoe/tc-custom/9780310354369.jpg?1703853058115" alt="This image is the cover for the book Winter Blessings, Seasons of an Amish Garden Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Winter Blessings, Seasons of an Amish Garden Stories
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In Amy Clipston's new novella collection, young Amish couples manage a community garden to raise money for a good cause, harvesting friendships and love along the way.</b></p><p>Ephraim and Mandy have plans to marry, but after an ugly argument, they decide to go their separate ways. Fortunately, their friends at the Amish garden conspire to bring them back together.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amy Clipston
      </h2>
      
      <p class="authorDescription body article"><P>Amy Clipston is an award-winning bestselling author and has been writing for as long as she can remember. She's sold more than one million books, and her fiction writing "career" began in elementary school when she and a close friend wrote and shared silly stories. She has a degree in communications from Virginia Wesleyan University and is a member of the Authors Guild, American Christian Fiction Writers, and Romance Writers of America. Amy works full-time for the City of Charlotte, NC, and lives in North Carolina with her husband, two sons, mother, and four spoiled rotten cats. Visit her online at AmyClipston.com; Facebook: @AmyClipstonBooks; Twitter: @AmyClipston; Instagram: @amy_clipston; BookBub: @AmyClipston.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsChristianPublishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5362654a